export default __webpack_public_path__ + "static/media/ic_1inch.4273e7f6.svg";